import generateReportModalReducer from './slice';

export default generateReportModalReducer;

export * from './data';
export * from './selectors';
export * from './slice';
export * from './types';
